import { cssRule } from 'typestyle';

cssRule('div.tb-reset-start-page-help', {
    whiteSpace: 'normal',
});

